export const userIsDemoOrNot= (data) => {
    return data === '+989190191914';
};